import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { Loader } from "../common";
import Pagination from "react-js-pagination";
import { getChangesToPaymentsTable } from "../../actions";
import { convertToCurrencyFormat } from "../../helpers/Utils";
import moment from "moment";
import StyleConstants from "../../shared/constants/styleConstants/styles";

class PaymentChanges extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      perPage: 10,
    };
  }

  async componentDidMount() {
    await this.props.getChangesToPaymentsTable();
  }

  noPermission() {
    return (
      <div
        style={{
          paddingTop: 200,
          paddingLeft: 300,
          width: "100%",
          backgroundColor: "#F5F8FA",
          fontSize: "20px",
        }}
      >
        <span style={{ borderStyle: "solid", padding: "10px" }}>
          You dont have permission to access Payments history{" "}
        </span>
      </div>
    );
  }

  render() {
    const { page, perPage } = this.state;
    const { paymentChanges, isLoading, userDetails } = this.props;

    if (
      !userDetails.permissions?.includes("Admin") &&
      !userDetails.permissions?.includes("Finance Admin")
    ) {
      return this.noPermission();
    }

    if (isLoading) {
      return <Loader />;
    }

    return (
      <div style={{ margin: 30 }}>
        <div
          style={{
            fontWeight: "bold",
            color: StyleConstants.color.darkBlue,
            margin: "auto 0",
            paddingBottom: "10px",
          }}
        >
          Payments and Refunds Edits
        </div>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th style={{ width: 40 }}>S.no.</th>
              <th style={{ width: 150 }}>Student Details</th>
              <th style={{ width: 280 }}>Fee Details</th>
              <th style={{ width: 120, textAlign: "right" }}>Amount Change</th>
              <th style={{ textAlign: "right" }}>Difference</th>
              <th style={{ width: 100, textAlign: "right" }}>Change Date</th>
              <th style={{ width: 150 }}>Done By</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            {paymentChanges.length > 0 &&
              paymentChanges
                .sort((a, b) => moment(b.created_at) > moment(a.created_at))
                .slice((page - 1) * perPage, page * perPage)
                .map((paymentChange, index) => {
                  return (
                    <tr
                      key={(page - 1) * perPage + index + 1}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        window.location.replace(
                          `/fee_collection?id=${paymentChange.student_id}`
                        )
                      }
                    >
                      <td>{(page - 1) * perPage + index + 1}</td>
                      <td style={{ fontSize: 13 }}>
                        {paymentChange.student_name || "-"}
                        <br />
                        {paymentChange.badge_id || "-"}
                        <br />
                        {paymentChange.campus_name || "-"}
                        {"  "}
                        {paymentChange.classroom_name || "-"}
                      </td>
                      <td style={{ fontSize: 13 }}>
                        Fee Bundle: {paymentChange.fee_bundle_name}
                        <br />
                        Fee: {paymentChange.fee_name}
                        <br />
                        Tx ID: {paymentChange.transaction_id}
                        <br />
                        {paymentChange.item_type}
                      </td>
                      <td style={{ textAlign: "right", fontSize: 13 }}>
                        Old: {convertToCurrencyFormat(paymentChange.old_amount)}
                        <br />
                        New: {convertToCurrencyFormat(paymentChange.new_amount)}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {convertToCurrencyFormat(
                          paymentChange.old_amount - paymentChange.new_amount
                        )}
                      </td>
                      <td style={{ textAlign: "right" }}>
                        {moment(paymentChange.created_at).format("DD MMM 'YY")}
                      </td>
                      <td>{paymentChange.modifier_name}</td>
                      <td>{paymentChange.reason}</td>
                    </tr>
                  );
                })}
          </tbody>
        </table>
        <Pagination
          activePage={page}
          itemsCountPerPage={perPage}
          totalItemsCount={paymentChanges.length}
          pageRangeDisplayed={5}
          onChange={(pageNumber) => this.setState({ page: pageNumber })}
        />
      </div>
    );
  }
}

PaymentChanges.propTypes = {
  isLoading: PropTypes.bool,
  paymentChanges: PropTypes.array,
  userDetails: PropTypes.object,
};

PaymentChanges.defaultProps = {
  paymentChanges: [],
  isLoading: false,
};

const mapStateToProps = ({ home, auth }) => ({
  isLoading: home.isLoading,
  paymentChanges: home.paymentChanges,
  userDetails: auth.userDetails,
});

export default withRouter(
  connect(mapStateToProps, { getChangesToPaymentsTable })(PaymentChanges)
);
